<div class="d-print-none" id="viewport" style="opacity: 0">
  <form>
    <div id="footer" class="footer">
      <div class="get_intouch_sec">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="intouch_box">
                <div class="intouch_inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div class="container">
          <div class="support-entities-c">
            <div class="support-entities owl-carousel">
              <div class="first">
                <a
                  target="”_blank”"
                  href="https://mysteryshopperapp.ae/default/defaultd"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/UAEmysteryshopper.png"
                    [alt]="'HomeFooterMysteryShopper' | translate"
                  />
                </a>
              </div>
              <div class="first">
                <a
                  target="”_blank”"
                  href="https://171.ae/"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/tawasl-logo.png"
                    [alt]="'HomeFooter171' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  href="https://www.mof.gov.ae/ar/pages/default.aspx"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/MinistryofFinanceUAE.png"
                    [alt]="'HomeFooterMinistryOfFinance' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  href="https://www.mof.gov.ae/ar/pages/default.aspx"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/AbuDhabipolice.png"
                    [alt]="'HomeFooterADPolice' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  href="http://bayanat.ae/en"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/bayanat.png"
                    [alt]="'HomeFooterGovernmentdata' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  href="https://beeatna.ae/en"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/beeatna-en.png"
                    [alt]="'HomeFooterEnvironment' | translate"
                  />
                </a>
              </div>

              <div class="first">
                <a
                  target="”_blank”"
                  href="https://government.ae/{{ currentLang }}/participate"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/sharik.ae.png"
                    [alt]="'HomeFooterParticipation' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  href="http://uaesdgs.ae/en"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/uaesdgs202c.png"
                    [alt]="'HomeFooterSDGS' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  href="https://workinuae.ae/en"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/working-en202c.png"
                    [alt]="'HomeFooterWorkInUAE' | translate"
                  />
                </a>
              </div>

              <div>
                <a
                  target="”_blank”"
                  href="https://alameen.gov.ae/"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/AlAmeen.png"
                    [alt]="'HomeFooterAlAmeen' | translate"
                  />
                </a>
              </div>

              <div>
                <a
                  target="”_blank”"
                  href="https://esaad.dubaipolice.gov.ae/"
                  class="has-tool-tip"
                >
                  <img
                    src="assets/Images/siteimages/essad.png"
                    [alt]="'HomeFooterEsaad' | translate"
                  />
                </a>
              </div>
              <div>
                <a
                  target="”_blank”"
                  class="has-tool-tip"
                  href="https://www.skgep.gov.ae/"
                >
                  <img
                    src="assets/Images/siteimages/sheikh-khalifa-government-excellence-logo.PNG"
                    [alt]="
                      'HomeFooterSheikhKhalifaGovernmentExcellenceProgram'
                        | translate
                    "
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-section-last-update container">
        <p>
          {{ 'HomeFooterWebsitelastupdatedon' | translate
          }}<span data-toggle="last-update-date" class="last-modified">{{
            'HomeFooterDate' | translate
          }}</span>
        </p>
      </div>

      <div class="footer-container">
        <div class="container">
          <div class="newsletter-bar row">
            <div class="visitor-count col">
              <span class="key">
                {{ 'HomeFooterVisitorsCounter' | translate }}
              </span>
              <strong class="visitors-value">{{ visitorCount }}</strong>
            </div>
            <div class="col">
              <div class="our-apps">
                <div class="app-seciton">
                  <span class="section-label bold">
                    {{ 'DownloadMobileApps' | translate }}
                  </span>
                  <ul>
                    <li>
                      <a
                        class="fi-android-n lnk-tip"
                        title=""
                        href="https://play.google.com/store/apps/details?id=com.linkdev.moew.app"
                        data-original-title="{{ 'Android' | translate }}"
                        [attr.aria-label]="'Android' | translate"
                      ></a>
                    </li>
                    <li>
                      <a
                        class="fi-ios-n lnk-tip"
                        title=""
                        href="https://itunes.apple.com/ae/app/moccae/id765940884?mt=8"
                        data-original-title="{{ 'Apple' | translate }}"
                        [attr.aria-label]="'Apple' | translate"
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="newsletter col">
              <input
                id="subscribenewsletteremail"
                type="text"
                data-toggle="subscribenewsletteremail"
                placeholder="{{ 'SubscribeNewsletterEmail' | translate }}"
              />
              <label
                for="subscribenewsletteremail"
                href="javascript:void(0)"
                data-toggle="subscribenewsletterbtn"
                class="d-inline-block"
                >{{ 'Subscribe' | translate }} <i class="fi-submit-icon"></i
              ></label>
            </div>
          </div>
          <div class="bar"></div>

          <div class="menu-bar">
            <div class="logos">
              <ul class="gov-logos">
                <li>
                  <a
                    href="https://beeatna.ae/ar/home.aspx"
                    class="has-tool-tip scale-hover text-primary"
                  >
                    <img
                      [src]="
                        isArabic
                          ? 'assets/Images/siteimages/logo-new-ar.png'
                          : 'assets/Images/siteimages/logo-new-en.png'
                      "
                      [alt]="'trFooterEnvironment' | translate"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://u.ae/ar-ae"
                    class="has-tool-tip scale-hover"
                    title=""
                  >
                    <img
                      style="max-height: 80px"
                      src="/assets/Images/siteimages/government-ae-logo-english.png?1234"
                      [alt]="'trFooterUDotAE' | translate"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://beeatna.ae/ar/home.aspx"
                    class="has-tool-tip scale-hover"
                    title="{{ 'HomeFooterEnvironment' | translate }}"
                  >
                    <img
                      style="max-height: 80px"
                      src="/assets/Images/siteimages/beeatna-en.png?v=1"
                      [alt]="'trFooterBeeatna' | translate"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div class="footer-menu">
              <div class="submenu">
                <span class="label bold">{{
                  'AboutTheWebsite' | translate
                }}</span>
                <ul class="list">
                  <li>
                    <a
                      class="footer-link"
                      href="ar/copyright-notice.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterCopyrightNotice' | translate }}
                    </a>
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="ar/privacy-policy.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterPrivacyPolicy' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="ar/terms-and-conditions.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterTermsConditions' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="ar/disclaimer.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterDisclaimer' | translate }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="submenu col-2">
                <span class="label bold">
                  {{ 'HomeFooterQuicklinksInfo' | translate }}
                </span>
                <ul class="list">
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/newsletter-subscription.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterNewsletterSignup' | translate }}
                    </a>
                  </li>
                  <li>
                    <a class="footer-link" href="ar/home.aspx" target="_self">
                      {{ 'HomeFooterHome' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="ar/accessibility.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterAccessibility' | translate }}
                    </a>
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="https://mail.moccae.gov.ae/owa"
                      target="_self"
                    >
                      {{ 'HomeFooterEmployeesEmail' | translate }}
                    </a>
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="https://mygate.moccae.gov.ae"
                      target="_self"
                      >{{ 'HomeFooterMyGate' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="ar/careers.aspx"
                      target="_self"
                      >{{ 'HomeFooterCareers' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/our-services/happiness_eq_englishaspx.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterCustomerHappinessCharter' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/media-centre/archive.aspx"
                      target="_self"
                      >{{ 'HomeFooterArchive' | translate }}</a
                    >
                  </li>
                  <li>
                    <a class="footer-link" href="ar/faq.aspx" target="_self">
                      {{ 'HomeFooterFAQ' | translate }}
                    </a>
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/help/technical-support.aspx"
                      target="_self"
                      >{{ 'HomeFooterHelp' | translate }}
                    </a>
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/contact-us.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterContactUs' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/search.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterAdvancesearch' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="/ar/sitemap.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterSitemap' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="footer-link"
                      href="ar/customer-service-centers.aspx"
                      target="_self"
                    >
                      {{ 'HomeFooterCustomersHappinessCenters' | translate }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="best-viewd">
              <p [innerHTML]="'HomeFooterView' | translate"></p>
              <div class="main-section">
                <div class="sub-section">
                  <span class="title"> {{ 'Supports' | translate }} </span>
                  <div>
                    <span
                      ><i
                        class="fi-firefox-icon"
                        title="{{ 'MicrosoftInternetExplorer' | translate }}"
                      ></i>
                      10.0+
                    </span>
                    <span>
                      <i
                        class="fi-firefox-icon"
                        title="{{ 'Firefox' | translate }}  "
                      ></i>
                      48+
                    </span>
                    <span>
                      <i
                        class="fi-safari-icon"
                        title="{{ 'Safari' | translate }} "
                      ></i>
                      1.2+
                    </span>
                    <span
                      ><i
                        class="fi-opera-icon"
                        title="{{ 'Opera' | translate }} "
                      ></i>
                      39.0+
                    </span>
                    <span
                      ><i
                        class="fi-google-chrome-icon"
                        title="{{ 'GoogleChrome' | translate }}  "
                      ></i>
                      43.0+</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="copy-write-bar">
            <div class="bar"></div>
            <div class="text">{{ 'HomeFooterCopyRight' | translate }}</div>
            <div class="social">
              <ul class="footer-social-media">
                <li>
                  <a
                    class="fi-facebook-ico lnk-tip"
                    href="https://www.facebook.com/MoCCAEUAE/"
                    data-original-title="{{ 'Facebook' | translate }}"
                    [attr.aria-label]="'Facebook' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-twitter lnk-tip"
                    href="https://twitter.com/moccaeuae"
                    data-original-title="{{ 'Twitter' | translate }}"
                    [attr.aria-label]="'Twitter' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-youtube lnk-tip"
                    href="https://www.youtube.com/user/moewmedia"
                    data-original-title="{{ 'Youtube' | translate }}"
                    [attr.aria-label]="'Youtube' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-instagram lnk-tip"
                    href="https://www.instagram.com/moccaeuae/"
                    data-original-title="{{ 'Instagram' | translate }}"
                    [attr.aria-label]="'Instagram' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-linkedin-n lnk-tip"
                    href="https://www.linkedin.com/company/moccaeuae"
                    data-original-title="{{ 'Linkedin' | translate }}"
                    [attr.aria-label]="'Linkedin' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-pdf-icon lnk-tip"
                    href="https://get.adobe.com/uk/reader/"
                    data-original-title="{{ 'AdobeReader' | translate }}"
                    [attr.aria-label]="'AdobeReader' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-windows-ic lnk-tip"
                    href="https://support.microsoft.com/en-us/help/14209/get-windows-media-player"
                    data-original-title="{{ 'WindowMediaPlayer' | translate }}"
                    [attr.aria-label]="'WindowMediaPlayer' | translate"
                  ></a>
                </li>
                <li>
                  <a
                    class="fi-flash-player-ic lnk-tip"
                    href="https://get.adobe.com/flashplayer/"
                    data-original-title="{{ 'Flash' | translate }}"
                    [attr.aria-label]="'Flash' | translate"
                  ></a>
                </li>
              </ul>
            </div>
            <div class="tel">
              <span>{{ 'NeedHelp' | translate }}</span>
              <a href="tel:8003050"
                ><i class="fi-phone-globalmast-icon"></i><span>8003050</span></a
              >
            </div>
          </div>
        </div>
      </div>

      <!--/MOD_0e80884f-c8bf-410d-9551-f6bf5d4d30c7_157-->
    </div>
  </form>
</div>

